import { PendingStatus } from '@/classes/SubmissionStatuses/InsuranceStatuses/PendingStatus'

export class WaitingForSignatureStatus extends PendingStatus {
	getToolTipText() {
		return {
			title: this.getStatusText(),
			body: 'This packet is waiting on the Funeral Director’s signature, and will be submitted once signed. Have questions? Contact salesstudio@precoa.com.',
		}
	}
}
